import React, { useState, useEffect } from 'react'
import { withTranslation } from 'react-i18next';
import { useHistory, Link, useParams } from "react-router-dom";
import { useData } from "../../DataContext";
import { get, useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import * as moment from 'moment';
import { Helmet } from "react-helmet";
import { 
    FormControlLabel,
    FormControl,
    Button,
    Box,
    Checkbox,
    Typography,
    Backdrop,
    makeStyles,
    createStyles
} from '@material-ui/core';

import './TermsConditions.scss'

import { 
    Navbar,
    Header,
    StepHeader,
    FormBox,
    BootstrapInput,
    Footer
} from '../../components/_index'
import VehicleDetail from '../VehicleDetail/VehicleDetail';
import { useYupValidationResolver } from '../../YupValidationResolver';
import ErrorsContainer from '../../components/ErrorsContainer/ErrorsContainer';
import { checkIfRedirect, convertResponseToJson, isEmpty } from '../../utils';
import Scroll from 'react-scroll';
import errorWarning from '../../images/icon_warning.gif'
import charSet from '../../images/icon_kong.jpg'
import pps from '../../images/icon_pps.jpg'
import printer from '../../images/icon_printer.jpg'
import scanner from '../../images/icon_scanner.jpg'
import iAmSmart from '../../images/IAMSmart.jpg'
import td_logo from '../../images/td_logo_v1.svg'
import ReCAPTCHA from 'react-google-recaptcha';

const useStyles = makeStyles((theme) =>
  createStyles({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }),
);

export default withTranslation()(function TermsConditions({t, i18n}) {
    
    let scroll = Scroll.animateScroll;
    const classes = useStyles();
    const { setValues, data, emptyData } = useData();
    const history = useHistory();
    const { lang } = useParams();
    const [ backDropOpen, setBackDropOpen ] = useState(false);
    const [ temFormData, setTemFormData ] = useState({});
    const selectServiceURL = `${process.env.REACT_APP_SUB_ROUTE}/SelectService`;

    //change language
    const supportedLanguages = ["en", "tc"];
    console.log("lang: ", lang);
    console.log("i18n.language: ", i18n.language);
    if(i18n.language!==lang&&supportedLanguages.includes(lang)){
        console.log("changing language to: ", lang);
        i18n.changeLanguage(lang)
    }
    const recaptchaLang = i18n.language==="tc"?"zh-HK":"en-GB";

    const schema = yup.object().shape({
        agreeTermsConditions: yup.boolean().oneOf([true], t("errors.frontend.790-E-0801")),
        recaptcha: yup.boolean().oneOf([true], t("errors.frontend.790-E-0802")),
    })

    const { 
        register,
        control,
        handleSubmit, 
        errors,
        clearErrors,
        getValues,
        setValue,
    } = useForm({
        defaultValues: { 
            siteID: data.siteID,
            agreeTermsConditions: false,
            recaptcha: false,
        },
        mode: "onSubmit",
        resolver: useYupValidationResolver(schema),
    });

    const onSubmit = (formData) => {
        console.log("formData: ", formData)
        setValues(formData);
        setTimeout(()=>{history.push(selectServiceURL)}, 1000);
    };
    const onError = (errors) => {
        scroll.scrollToTop();
    }

    // TODO: iAMSmart Server redirect (does not work if domain is epas1. or epas2)
    // Screen ID server ID -> 0 = UAT, 1 = KP, 2 = SP
    //
    // Confirmation Reference Number format: 7902 1010 1000 0001
    // 790 – Application ID
    // 21 – Year
    // 01 – Month
    // 01 – Day
    // 0 – Hosting site (0 for UAT / DR, 1 for Production KP, 2 for Production SP)
    // 00 0001 – Sequence no. generate for the application submitted starting from 1 for a calendar day.
    //
    
    //debugger
    
    const [dnsData, setDnsData] = useState(null);
    
    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        console.log("DNS JSON: ", jsonData);
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    const [directlogin, setDirectLogin] = useState(JSON.parse(sessionStorage.getItem("directLogin")) || "");

    useEffect(()=>{
        if(sessionStorage.getItem("directLogin") != null){
            //for ias direct login user submitted form, could reuse themself data.
            setValues({
                iAMSmart:{
                    access: {
                        accessToken: directlogin?.accessToken,
                        openID: directlogin?.openID,
                        issueAt: directlogin?.issueAt,
                        expiresIn: directlogin?.expiresIn,
                        isDirectLogin: true
                    }
                }
            })
        }else{
            setValues({
                iAMSmart: undefined
            })
        }

    },[directlogin])
    
    // useEffect(() => {
    //     const url = `${window.location.origin}/EPASService/application/detectSiteID`
    //     console.log(url);
    //     fetch(url)
    //         .then((response)=>(response.json()))
    //         .then((jsonResponse)=>{
    //             if(jsonResponse.message==="ok"){
    //                 console.log("jsonResponse", JSON.parse(jsonResponse.data));
    //             }
    //         },
    //     []
    // )});

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }

    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+`-000`}</title>
            </Helmet>
            <Box className="wrapper TermsConditions">
                <Header />
                <Box className="mainWrapper">
                    <Navbar />
                    <Box className="contentWrapper">
                        <ErrorsContainer errors={errors} />
                        <form onSubmit={handleSubmit(onSubmit, onError)} noValidate>
                            <Box
                                display="none">
                                <BootstrapInput
                                    name="siteID"
                                    defaultValue="1"
                                    inputRef={register}
                                    id="siteID"
                                />
                            </Box>
                            <Box className="branding">
                                <img src={td_logo} alt="運輸署標誌 Logo of Transport Department" />
                            </Box>
                            <FormBox header="terms.notes">
                                <Box 
                                    p={5}
                                    className="wordwrap"
                                >
                                    <Box p={2}>
                                        <Typography component={'span'} variant="body1">
                                            <ul>
                                                <li>
                                                    {t('common.importantDesc7')} 
                                                </li>
                                            </ul>
                                        </Typography>
                                    </Box>
                                    <Box p={2}>
                                        <Typography component={'span'} variant="body1">
                                            <ul>
                                                <li>
                                                    {t('step1.tnc.tnc6')}<b><span className="danger">{t('step1.tnc.tnc7')}</span></b>{t('step1.tnc.tnc8')}
                                                </li>
                                            </ul>
                                        </Typography>
                                    </Box>
                                    
                                    <Box p={2}>
                                        <Typography component={'span'} variant="body1">
                                            <ul>
                                                <li>
                                                    {t('common.importantDesc8')} 
                                                </li>
                                            </ul>
                                        </Typography>
                                        <a 
                                            href={`https://www.td.gov.hk/${i18n.language=="zh-TW"?"en":i18n.language}/public_forms/td_forms/permit/`} 
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {`https://www.td.gov.hk/${i18n.language=="zh-TW"?"en":i18n.language}/public_forms/td_forms/permit/`}
                                        </a>
                                    </Box>
                                    <Box p={2}>
                                        <Typography component={'span'} variant="body1">
                                        <ul>
                                            <li>{t('common.importantDesc9')} 
                                            </li>                        
                                        </ul>
                                        <ul>
                                            <li>{t('common.importantDesc1')} 
                                                <b><span className="danger">{t('common.importantDesc2')}</span></b>
                                                {t('common.importantDesc3')}
                                            </li>                        
                                        </ul>
                                        </Typography>
                                        <Typography variant="subtitle1">
                                            {t('common.importantLink1')}
                                        </Typography>
                                        <a 
                                            href={`https://www.td.gov.hk/${i18n.language=="zh-TW"?"en":i18n.language}/public_services/licences_and_permits/lantau_closed_road_permit/index.html`} 
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {`https://www.td.gov.hk/${i18n.language=="zh-TW"?"en":i18n.language}/public_services/licences_and_permits/lantau_closed_road_permit/index.html`}
                                        </a>
                                        <Typography variant="subtitle1">
                                            {t('common.importantLink2')}
                                        </Typography>
                                        <a 
                                            href={`https://www.td.gov.hk/${i18n.language=="zh-TW"?"en":i18n.language}/public_services/licences_and_permits/closed_road_permit_for_cross_boundary_vehicles/index.html`} 
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {`https://www.td.gov.hk/${i18n.language=="zh-TW"?"en":i18n.language}/public_services/licences_and_permits/closed_road_permit_for_cross_boundary_vehicles/index.html`}
                                        </a>
                                        <Typography variant="subtitle1">
                                            {t('common.importantLink5')}
                                        </Typography>
                                        <a 
                                            href={`https://www.police.gov.hk/ppp_${i18n.language=="zh-TW"?"en":i18n.language}/11_useful_info/licences/cap_notes.html`} 
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            {`https://www.police.gov.hk/ppp_${i18n.language=="zh-TW"?"en":i18n.language}/11_useful_info/licences/cap_notes.html`}
                                        </a>
                                    </Box>
                                    <Box p={2}>
                                        <Typography component={'span'} variant="body1">
                                        <ul>
                                            <li>
                                                {t('common.importantDesc4')}
                                            </li>
                                        </ul>
                                        </Typography>
                                    </Box>
                                </Box>
                            </FormBox>
                            <FormBox header="terms.majorsteps.title">
                                <Box p={5}>
                                    <Typography variant="body1">
                                        {t('terms.majorsteps.timetaken')}
                                    </Typography>
                                </Box>
                                <hr />
                                <Box p={5}>
                                    <div className="majorSteps">
                                        <div className="divTableBody">
                                            <div className="divTableRow">
                                                <div className="divTableCell">
                                                    <Typography variant="body1" className="bold">
                                                        {t('common.step1')}
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {t('common.step1Title')}
                                                    </Typography>
                                                </div>
                                                <div className="divTableCell">
                                                    <Typography variant="body1" className="bold">
                                                        {t('common.step3')}
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {t('common.step3Title')}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div className="divTableRow">
                                                <div className="divTableCell">
                                                    <Typography variant="body1" className="bold">
                                                        {t('common.step2')}
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {t('common.step2Title')}
                                                    </Typography>
                                                </div>
                                                <div className="divTableCell">
                                                    <Typography variant="body1" className="bold">
                                                        {t('common.step4')}
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {t('common.step4Title')}
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </FormBox>
                            <FormBox header="terms.requireditems.title">
                                <Box p={5}>
                                    <div className="requiredItems">
                                        <div className="divTableBody">
                                            {/*
                                            <div className="divTableRow">
                                                <div className="divTableCell center icon"><img src={charSet} alt={t('terms.requireditems.hkcharset')} /></div>
                                                <div className="divTableCell description">
                                                    <Typography variant="body1">
                                                        {t('terms.requireditems.hkcharset')}
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {t('terms.requireditems.hkcharsetdec')}
                                                    </Typography>
                                                </div>
                                                <div className="divTableCell download">
                                                    <a href={`http://www.ogcio.gov.hk/${i18n.language=="zh-TW"?"en":i18n.language}/business/tech_promotion/ccli/download_area/`} target="new">
                                                        {t('terms.requireditems.download')}
                                                    </a>
                                                </div>
                                            </div>
                                            */}
                                            <div className="divTableRow">
                                                <div className="divTableCell center icon"><img src={printer} alt={t('terms.requireditems.printer')} /></div>
                                                <div className="divTableCell description">
                                                        <Typography variant="body1">
                                                            {t('terms.requireditems.printer')}{t('terms.requireditems.optional')}
                                                        </Typography>
                                                        <Typography variant="body1">
                                                            {t('terms.requireditems.printerdec')}
                                                        </Typography>
                                                </div>
                                                <div className="divTableCell">&nbsp;</div>
                                            </div>
                                            <div className="divTableRow">
                                                <div className="divTableCell center icon"><img src={scanner} alt={t('terms.requireditems.scanner')} /></div>
                                                <div className="divTableCell description">
                                                    <Typography variant="body1">
                                                        {t('terms.requireditems.scanner')}{t('terms.requireditems.optional')}
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {t('terms.requireditems.scannerdec')}
                                                    </Typography>
                                                </div>
                                                <div className="divTableCell">&nbsp;</div>
                                            </div>
                                            <div className="divTableRow">
                                                <div className="divTableCell center icon"><img src={iAmSmart} className="iamSmart" alt={t('terms.requireditems.smartphone')}/></div>
                                                <div className="divTableCell description">
                                                    <Typography variant="body1">
                                                        {t('terms.requireditems.smartphone')}{t('terms.requireditems.optional')}
                                                    </Typography>
                                                    <Typography variant="body1">
                                                        {t('terms.requireditems.smartphonedec')}
                                                        &nbsp;
                                                        <span>(<a href={t('step2.iamSmart.link')} target="_new">{t('terms.requireditems.moreinfo')}</a>)</span>
                                                    </Typography>
                                                </div>
                                                <div className="divTableCell">&nbsp;</div>
                                            </div>
                                        </div>
                                    </div>
                                </Box>
                            </FormBox>
                            <FormBox header="step1.tnc.title">
                                <Box
                                    p={5}
                                    bgcolor="tnc.main"
                                >
                                    <ol className="tncList">
                                        <li>{t('step1.tnc.tnc1')}</li>
                                        <li>{t('step1.tnc.tnc2')}</li>
                                        <li>{t('step1.tnc.tnc3')}</li>
                                        <li>{t('step1.tnc.tnc4')}</li>
                                        <li>
                                            {t('step1.tnc.tnc5')}
                                            <Link to={`${process.env.REACT_APP_SUB_ROUTE}/Privacy`} target="_blank" rel="noopener noreferrer">
                                                {t('step1.tnc.notesOnPrivacy')}
                                            </Link>
                                            <span>{t('step1.tnc.fullstop')}</span>
                                        </li>
                                    </ol>
                                </Box>
                            </FormBox>
                            <FormBox>
                                <Box p={5}>
                                    <FormControl
                                        error={!!errors.agreeTermsConditions}
                                        required 
                                    >
                                        <Controller
                                            control={control}
                                            id="agreeTermsConditions"
                                            name="agreeTermsConditions"
                                            render={(props) =>
                                                <label className="MuiFormControlLabel-root">
                                                    <Checkbox 
                                                        checked={props.value}
                                                        color="primary"   
                                                        onChange={(e) =>{
                                                            props.onChange(e.target.checked);
                                                        }}
                                                    />
                                                    <span>{t('step1.agreeTnc')}</span>
                                                    {!!errors.agreeTermsConditions ? <img id="agreeTermsConditions_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> : <div></div>}
                                                </label>
                                            }
                                        />
                                    </FormControl>
                                </Box>
                            </FormBox>
                            {
                                process.env.REACT_APP_ENV_TYPE !== "GNET" &&
                                <FormBox header="step1.recaptcha.title">
                                    <Box p={2}>
                                        <Typography variant="body1">
                                            {t("step1.recaptcha.content")}
                                            {!!errors.agreeTermsConditions && <img id="agreeTermsConditions_errorIcon" className="errorWarning" src={errorWarning} alt="error" /> }
                                        </Typography>
                                    </Box>
                                    <Box p={2}>
                                        <ReCAPTCHA
                                            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                            onChange={()=>{setValue("recaptcha", true)}}
                                            hl={recaptchaLang}
                                        />
                                        <input type="hidden" name="recaptcha" ref={register()}/>
                                    </Box>
                                </FormBox>
                            }
                            
                            <FormBox>
                                <Box
                                    display="flex" 
                                    justifyContent="flex-end"
                                >
                                    
                                    <Button 
                                        variant="contained" 
                                        color="primary" 
                                        type="submit"
                                    >
                                        {t('common.button.submit')}
                                    </Button>
                                </Box>
                            </FormBox>
                        </form>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </main>
    )
})
